import confirmMarkAsPhishing from './helpers/confirmMarkAsPhishing';
import createItemContextsForDeleteStoreUpdate from './helpers/createItemContextsForDeleteStoreUpdate';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import filterRowKeysByExistence from './helpers/filterRowKeysByExistence';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import markItemsAsPhishingBasedOnItemIds from './helpers/markItemsAsPhishingBasedOnItemIds';
import { ActionSource } from 'owa-analytics-actions';
import { getRowIdsFromRowKeys, TableView } from 'owa-mail-list-store';
import { userMailInteractionAction } from 'owa-mail-actions';

/**
 * mark items as phishing given the row keys
 * @param rowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source
 */
export default function markItemsAsPhishingFromTable(
    rowKeys: string[],
    tableView: TableView,
    actionSource: ActionSource
) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing(() => {
        markItemsAsPhishingInternal(rowKeys, tableView, actionSource);
    });
}

/**
 * mark items as phishing internal handler
 * @param rowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source
 */
function markItemsAsPhishingInternal(
    rowKeys: string[],
    tableView: TableView,
    actionSource: ActionSource
) {
    // Since rows may have been deleted from the table while the confirm dialog was open,
    // we need to validate the rows exist before proceeding
    const filteredRowKeys = filterRowKeysByExistence(rowKeys, tableView);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    const instrumentationContexts = getInstrumentationContextsFromTableView(rowKeys, tableView);

    // Get the de-duped item ids from the row keys
    const itemIds = getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    markItemsAsPhishingBasedOnItemIds(itemIds, tableView, actionSource, () => {
        const itemContexts = createItemContextsForDeleteStoreUpdate(itemIds);

        // Dispatch action to update the store state
        deleteItemsStoreUpdate(itemContexts, tableView.tableQuery.folderId, 'MarkAsPhishing');
    });
    userMailInteractionAction('MarkAsPhishing', instrumentationContexts);
}
